import React, { useEffect, useState } from 'react'
import useCorsi from '../../hooks/useCorsi'
import CorsoCard from '../../components/CorsoCard/CorsoCard';
import CorsoCardLoading from '../../components/CorsoCardLoading/CorsoCardLoading';
import useCorsiUtenti from '../../hooks/useCorsiUtenti';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';
import useClassi from '../../hooks/useClassi';
import useClassiUtenti from '../../hooks/useClassiUtenti';
import { useLocation } from 'react-router-dom';

const CorsiPage = () => {
/*   const { getCorsiUtenteByToken } = useCorsiUtenti(); */
  const { getClassiUtenteByToken } = useClassiUtenti();
  const { getClassiByParamsNoAuth } = useClassi();
  const [corsi, setCorsi] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const user = useSelector((state) => state.user.userData);
  //const idSP = localStorage.getItem("idSP");
  //console.log("idSP: " + idSP);

  // useEffect(() => {
  //   fetchCorsi();
  // }, [user]);

  const location = useLocation();
    
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const idSP = params.get("id_sp");
    
    // Se trovo id_sp nell'URL della pagina di accesso/registrazione,
    // lo salvo in localStorage. Sarà usato da AccediForm dopo il login.
    if (idSP) {
      localStorage.setItem("idSP", idSP);
    }

    fetchCorsi();
    // Non lo rimuovo qui, perché mi serve che persista durante il processo.
    // Verrà rimosso da CorsiPage quando si tornerà alla vetrina principale.
  }, [location.search, user]);
  
  const fetchCorsi = async () => {
    setIsLoading(true);
    try {
      //console.log("idSP: " + localStorage.getItem('idSP'));
      const classiResponse = await getClassiByParamsNoAuth({
        filtri: {
          stato: 'Attivo'
        },
        usern: localStorage.getItem("username"),//NEW
        idSP: localStorage.getItem('idSP')
      });
      // console.log(classiResponse);
      // alert("STOP");
      const classi = classiResponse?.data || [];
      
      if (user?.sub && user?.role === ROLES.CORSISTA) {
        const purchasedClassi = await getClassiUtenteByToken();
        
        const purchasedClassiMap = new Map(
          purchasedClassi.map(classe => [
            Number(classe.id_classe), 
            {
              pagato: classe.stato_pagamento === 'Pagato',
              sconto: classe.sconto || 0,
              scontoAttivo: classe.sconto_corsista === 1,
              stato_pagamento: classe.stato_pagamento,
              id_classe_utente: classe.id_classe_utente,
              cond1: classe.cond1,//NEW
              cond2: classe.cond2,//NEW
              cond3: classe.cond3,//NEW
              is_bonifico_corsista : classe.is_bonifico_corsista//NEW
            }
          ])
        );
        
        const corsiWithPagato = classi.map(classe => {
          const classeInfo = purchasedClassiMap.get(Number(classe.id_classe));
          return {
            ...classe.corso,
            id_corso: Number(classe.corso.id_corso),
            pagato: classeInfo?.pagato || false,
            sconto: classeInfo?.sconto || 0,
            scontoAttivo: classeInfo?.scontoAttivo || false,
            stato_pagamento: classeInfo?.stato_pagamento || null,
            id_classe_utente: classeInfo?.id_classe_utente || null,
            cond1: classeInfo?.cond1 || 0,//NEW
            cond2: classeInfo?.cond2 || 0,//NEW
            cond3: classeInfo?.cond3 || 0,//NEW
            is_bonifico_corsista: classeInfo?.is_bonifico_corsista || 0,//NEW
            data_inizio_classe: classe.data_inizio,
            data_fine_classe: classe.data_fine,
            id_classe: classe.id_classe,
            docenti: classe.docenti,
            denominazione_classe: classe.denominazione,
            sede: classe.sede,
            numero_iscritti: classe.numero_iscritti,
            numero_massimo_corsisti: classe.numero_massimo_corsisti
          };
        });
        
        setCorsi(corsiWithPagato);
      } else {
        const corsiWithPagato = classi.map(classe => ({
          ...classe.corso,
          id_corso: Number(classe.corso.id_corso),
          pagato: false,
          data_inizio_classe: classe.data_inizio,
          data_fine_classe: classe.data_fine,
          id_classe: classe.id_classe,
          denominazione_classe: classe.denominazione,
          sede: classe.sede,
          docenti: classe.docenti,
          numero_iscritti: classe.numero_iscritti,
          numero_massimo_corsisti: classe.numero_massimo_corsisti,
          sconto_superpartner: classe.corso.sconto_superpartner
        }));
        setCorsi(corsiWithPagato);
      }
    } catch (error) {
      console.error("Errore nel caricamento dei corsi:", error);
      setCorsi([]);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="container my-5">
      <div className="row">
        {isLoading
          ? Array.from({ length: 8 }).map((_, index) => <CorsoCardLoading key={index} />)
          : corsi.length > 0
            ? corsi.map(corso => (
                <CorsoCard 
                  key={`${corso.id_corso}-${corso.id_classe}`} 
                  courseData={corso}
                  userRole={user?.role}
                  isLoggedIn={!!user}
                />
              ))
            : (
                <div className="col-12 text-center py-5">
                  <p className="text-muted fs-5">Nessun corso disponibile al momento.</p>
                  <p className="text-muted small">Torna a controllare più tardi per nuove proposte formative.</p>
                </div>
              )
        }
      </div>
    </div>
  );
}

export default CorsiPage
